import React from "react";
import s from "./style.module.scss";
import InviteForm from "features/InviteForm";

const InviteContent: React.FC = () => {
  return (
    <section className={s.invite}>
      <h1>Пригласи друга</h1>

      <p>
        Чтобы получить +5 баллов, введите номер телефона друга, нажмите на
        кнопку "Пригласить" и отправьте ссылку своему другу. После регистрации
        друга на Ваш счет будут заичслены дополнительные бонусы!
      </p>

      <InviteForm />
    </section>
  );
};

export default InviteContent;
